export enum TransactionColumn {
  DATE = 'date',
  TYPE = 'type',
  METHOD = 'paymentType',
  AMOUNT = 'fromAmount',
  FROM = 'fromAccount',
  TO = 'toAccount',
  STATUS = 'status',
  MARKUP = 'markup',
  EARNED = 'earned',
}

export const ALL_ACTIVITY_COLUMNS: readonly TransactionColumn[] = [
  TransactionColumn.DATE,
  TransactionColumn.TYPE,
  TransactionColumn.METHOD,
  TransactionColumn.AMOUNT,
  TransactionColumn.FROM,
  TransactionColumn.TO,
  TransactionColumn.STATUS,
];

export const CUSTOMER_ACTIVITY_COLUMNS: readonly TransactionColumn[] = [
  TransactionColumn.DATE,
  TransactionColumn.TYPE,
  TransactionColumn.METHOD,
  TransactionColumn.AMOUNT,
  TransactionColumn.TO,
  TransactionColumn.STATUS,
];

export const EARNINGS_ACTIVITY_COLUMNS: readonly TransactionColumn[] = [
  TransactionColumn.DATE,
  TransactionColumn.TYPE,
  TransactionColumn.METHOD,
  TransactionColumn.AMOUNT,
  TransactionColumn.FROM,
  TransactionColumn.TO,
  TransactionColumn.MARKUP,
  TransactionColumn.EARNED,
];
